import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";
import { Train } from "lucide-react";

export default function EmployerLogin() {
  const [email, setEmail] = useState(""); const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await login(email, password);
      toast.success(`Welcome back, ${r.user.contact_name || r.user.company_name}`);
      nav(r.user.role === "admin" ? "/admin/dashboard" : "/employer-portal/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-cream grid md:grid-cols-2">
      <div className="hidden md:flex bg-navy text-bone p-12 flex-col justify-between relative overflow-hidden">
        <div className="livery-stripe h-1 absolute top-0 left-0 right-0" />
        <Link to="/" className="flex items-center gap-3" data-testid="login-home-link">
          <img src="/logo.png" alt="Railway Careers UK" className="w-10 h-10 rounded-full bg-cream" />
          <div className="font-display font-extrabold tracking-tight">Railway Careers UK</div>
        </Link>
        <div>
          <Train className="w-12 h-12 text-amber mb-4" />
          <h1 className="font-display font-extrabold text-4xl tracking-tight leading-tight">Employer portal.</h1>
          <p className="text-bone/70 mt-3 max-w-sm">Post vacancies, track listings and reach the UK rail talent pool.</p>
        </div>
        <div className="text-xs text-bone/40 font-mono">Secure · TLS 1.3 · UK-hosted</div>
      </div>

      <div className="flex items-center justify-center p-8 md:p-12">
        <form onSubmit={submit} className="w-full max-w-md" data-testid="emp-login-form">
          <div className="text-xs uppercase tracking-[0.2em] font-semibold text-ink">Sign in</div>
          <h2 className="font-display font-extrabold text-ink text-3xl tracking-tight mt-2">Employer / Admin sign-in</h2>
          <p className="text-muted-foreground mt-2 text-sm">Use the credentials sent to you when your account was approved.</p>
          <div className="mt-6 space-y-4">
            <div><Label>Email</Label><Input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1" data-testid="emp-login-email" /></div>
            <div>
              <div className="flex items-center justify-between">
                <Label>Password</Label>
                <Link to="/forgot-password" className="text-xs text-ink/70 hover:text-ink underline-offset-4 hover:underline" data-testid="emp-login-forgot">Forgot?</Link>
              </div>
              <Input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1" data-testid="emp-login-password" />
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-navy text-bone hover:bg-lime-600 hover:text-ink font-semibold" data-testid="emp-login-submit">{loading ? "Signing in…" : "Sign in"}</Button>
          </div>
          <div className="mt-6 text-sm text-muted-foreground">No account? <Link to="/employer-portal/register" className="text-ink font-semibold underline-offset-4 hover:underline">Create one →</Link></div>
        </form>
      </div>
    </div>
  );
}
